(() => {
  function initialize(root = document) {
    root.querySelectorAll('.tx-railbar').forEach(bar => {
      if (bar.dataset.ready) return;
      const rail = document.getElementById(bar.dataset.rail);
      if (!rail) return;
      bar.dataset.ready = 'true';
      const thumb = bar.querySelector('.tx-railbar-thumb');
      let dragging = false, startX = 0, startScroll = 0;
      function update() {
        const max = rail.scrollWidth - rail.clientWidth;
        bar.hidden = max <= 1;
        const fraction = Math.min(1, rail.clientWidth / Math.max(1, rail.scrollWidth));
        const width = Math.max(24, bar.clientWidth * fraction);
        thumb.style.width = `${width}px`;
        thumb.style.transform = `translateX(${max > 0 ? (bar.clientWidth - width) * rail.scrollLeft / max : 0}px)`;
        bar.setAttribute('aria-valuenow', String(max > 0 ? Math.round(100 * rail.scrollLeft / max) : 0));
      }
      function finish() { dragging = false; bar.classList.remove('tx-dragging'); rail.classList.remove('tx-no-snap'); }
      bar.addEventListener('pointerdown', event => {
        if (event.button !== 0) return;
        event.preventDefault(); bar.focus(); rail.classList.add('tx-no-snap');
        if (event.target !== thumb) {
          const rect = bar.getBoundingClientRect(), size = thumb.getBoundingClientRect().width;
          rail.scrollLeft = (event.clientX - rect.left - size / 2) / Math.max(1, rect.width - size) * (rail.scrollWidth - rail.clientWidth);
        }
        dragging = true; startX = event.clientX; startScroll = rail.scrollLeft;
        bar.classList.add('tx-dragging'); bar.setPointerCapture(event.pointerId); update();
      });
      bar.addEventListener('pointermove', event => {
        if (!dragging) return;
        rail.scrollLeft = startScroll + (event.clientX - startX) / Math.max(1, bar.clientWidth - thumb.getBoundingClientRect().width) * (rail.scrollWidth - rail.clientWidth);
        update();
      });
      bar.addEventListener('pointerup', finish); bar.addEventListener('pointercancel', finish); bar.addEventListener('lostpointercapture', finish);
      bar.addEventListener('keydown', event => {
        const max = rail.scrollWidth - rail.clientWidth;
        const targets = {ArrowRight: rail.scrollLeft + rail.clientWidth * .8, ArrowLeft: rail.scrollLeft - rail.clientWidth * .8, Home: 0, End: max};
        if (!(event.key in targets)) return;
        event.preventDefault(); rail.scrollLeft = targets[event.key]; update();
      });
      rail.addEventListener('scroll', update, {passive: true});
      const observer = new ResizeObserver(update); observer.observe(rail);
      [...rail.children].forEach(child => observer.observe(child));
      const section = bar.closest('.shopify-section');
      if (section) section.addEventListener('shopify:section:unload', () => observer.disconnect(), {once: true});
      update();
    });

    root.querySelectorAll('.tx-hbanner').forEach(banner => {
      if (banner.dataset.ready) return;
      banner.dataset.ready = 'true';
      const track = banner.querySelector('.tx-hb-track');
      const dots = banner.querySelector('.tx-hb-dots');
      const slides = [...track.children];
      let current = 0;
      dots.removeAttribute('role');
      function show(index) {
        current = (index + slides.length) % slides.length;
        track.style.transform = `translateX(${-current * 100}%)`;
        slides.forEach((slide, i) => { slide.inert = i !== current; slide.setAttribute('aria-hidden', i !== current); });
        [...dots.children].forEach((dot, i) => dot.setAttribute('aria-current', String(i === current)));
      }
      slides.forEach((slide, i) => {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'tx-hb-dot';
        button.setAttribute('aria-label', slide.querySelector('img')?.alt || `Banner ${i + 1}`);
        button.addEventListener('click', () => show(i)); dots.append(button);
      });
      banner.querySelector('#hbPrev').addEventListener('click', () => show(current - 1));
      banner.querySelector('#hbNext').addEventListener('click', () => show(current + 1));
      show(0);
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
